import React, {useEffect, useState} from 'react'
import {Field, Formik, Form} from 'formik'
import {Modal} from 'react-bootstrap'
import useUtils from '../useUtils'
import {KTSVG} from '../../../../_metronic/helpers'

function Step2() {
  const {modifyBenefits, fetchBenefits, addBenefit, deleteBenefit, fetchBenefit, editBenefit} =
    useUtils()
  const [benefits, setBenefits] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [newBenefitName, setNewBenefitName] = useState('')
  const [editable, setEditable] = useState(null)

  const getBenefits = async () => {
    try {
      const data = await fetchBenefits()
      setBenefits(data?.records)
    } catch (error) {
      console.error('Error fetching settings:', error.message)
    }
  }

  useEffect(() => {
    getBenefits()
  }, [])

  const handleToggle = async (id, isActive) => {
    try {
      await modifyBenefits(id, {isActive: !isActive})
      setBenefits((prevBenefits) =>
        prevBenefits.map((benefit) =>
          benefit.id === id ? {...benefit, isActive: !isActive} : benefit
        )
      )
    } catch (error) {
      console.error('Error toggling benefit:', error.message)
    }
  }

  const handleEdit = async (id) => {
    try {
      const res = await fetchBenefit(id)
      setEditable(res)
      setShowModal(true)
      setNewBenefitName(res?.name)
    } catch (error) {
      console.error('Error editing benefit:', error.message)
    }
  }

  const handleAddBenefit = async () => {
    if (!newBenefitName.trim()) return alert('Benefit name is required')
    try {
      if (editable) {
        await editBenefit(editable?.id, {name: newBenefitName})
        setBenefits((prevBenefits) =>
          prevBenefits.map((benefit) =>
            benefit.id === editable.id ? {...benefit, name: newBenefitName} : benefit
          )
        )
        setNewBenefitName('')
        setShowModal(false)
        setEditable(null)
      } else {
        const newBenefit = await addBenefit({name: newBenefitName, isActive: false})
        setBenefits((prevBenefits) => [...prevBenefits, newBenefit])
        setNewBenefitName('')
        setShowModal(false)
      }
    } catch (error) {
      console.error('Error adding benefit:', error.message)
    }
  }

  const handleDeleteBenefit = async (id) => {
    try {
      await deleteBenefit(id)
      setBenefits((prevBenefits) => prevBenefits.filter((benefit) => benefit.id !== id))
    } catch (error) {
      console.error('Error deleting benefit:', error.message)
    }
  }

  return (
    <div className='d-flex flex-column align-items-center mx-auto mw-600px w-100 pt-15 pb-10'>
      {benefits ? (
        <Formik
          enableReinitialize
          initialValues={{
            benefits: benefits.reduce((acc, benefit) => {
              acc[benefit.id] = benefit.isActive
              return acc
            }, {}),
          }}
          onSubmit={(values) => {
            console.log('Form Submitted:', values)
          }}
        >
          {({values}) => (
            <Form className='mx-auto w-100 pb-10'>
              <div className='w-100'>
                {benefits.map((benefit) => (
                  <div
                    key={benefit.id}
                    className='mb-4 d-flex justify-content-between align-items-center'
                  >
                    <span className='fs-6 fw-bold'>{benefit.name}</span>
                    <div className='d-flex align-items-center gap-3'>
                      <label className='form-check form-check-custom form-check-solid form-switch'>
                        <Field
                          name={`benefits.${benefit.id}`}
                          type='checkbox'
                          className='form-check-input'
                          checked={values.benefits[benefit.id]}
                          onChange={() => handleToggle(benefit.id, benefit.isActive)}
                        />
                      </label>
                      <div className='d-flex align-items-center'>
                        <a
                          onClick={() => handleEdit(benefit.id)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        >
                          <KTSVG
                            path='/media/icons/duotune/art/art005.svg'
                            className='svg-icon-3 svg-icon-primary'
                          />
                        </a>
                        <a
                          onClick={() => handleDeleteBenefit(benefit.id)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen027.svg'
                            className='svg-icon-3 text-danger'
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
                <div className='d-flex mt- justify-content-center'>
                  <button
                    type='button'
                    className='btn btn-primary mt-5'
                    onClick={() => setShowModal(true)}
                  >
                    Add Benefit
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      )}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false)
          setEditable(null)
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> {editable ? 'Edit Benefit' : 'Add New Benefit'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type='text'
            className='form-control'
            placeholder='Benefit Name'
            value={newBenefitName}
            onChange={(e) => setNewBenefitName(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-secondary' onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button className='btn btn-primary' onClick={handleAddBenefit}>
            {editable ? 'Update' : 'Add'}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default Step2
